export const COMAPNIES = '/companies';
export const PENDING_REGISTRATION = '/registration-requests';



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/consts/requests.ts